import React from 'react';
import {Flex, Text, Button} from '@priority-software/priority-style-react';
import texts from '../../../../../../Localization/AISearch/texts';
import {allowAISearch} from '../../utils';
import styles from '../AISearchBlock/styles.module.scss';

type Props = {
    blockWrapperClass?: string;
    openAISearch?: () => void;
};

export const PromotionBlock = ({blockWrapperClass = '', openAISearch}: Props) => {
    if (!allowAISearch()) {
        return null;
    }
    return (
        <Flex
            direction="column"
            alignItems="center"
            style={{gap: 16}}
            componentClasses={blockWrapperClass}
        >
            <Text skin="paragraph-1">{texts.ai_search_promotion_text}</Text>
            <Button
                skin="aierp"
                size="medium"
                onClick={openAISearch}
                dataTestId="search-block-ai-btn"
                children={
                    <Text skin="paragraph-2" componentClasses={styles.aiLabel}>
                        {texts.ai_label}
                    </Text>
                }
            />
        </Flex>
    );
};
